import React from 'react'

export interface JoinButtonProps {
  children?: React.ReactNode
}

export const JoinButton: React.FC<JoinButtonProps> = ({ children }) => (
  <a className='pro-closest-shadow button font-semibold text-white bg-steel-grey-600 cta-button' data-open='sign-up-modal'>
    {children}
  </a>
)
